import { Component, Input } from '@angular/core';
import { globalModules } from '../../utils/global-modules';

@Component({
  selector: 'app-accordion',
  standalone: true,
  imports: [...globalModules],
  templateUrl: './accordion.component.html',
  styleUrl: './accordion.component.css'
})
export class AccordianComponent {
  @Input() id: number = 0
  @Input() title: string = '';
 
}
